import { StyledSelectDinamic } from "./styles";

export const SelectCidade = ({id, nome, options, setData, selecionado}) => {
  return (
    <StyledSelectDinamic>
      <div className="select-label">
        {/* <label htmlFor="">{titulo}</label> */}
        <select id="selectCidade" className="select" onChange={(e) => { setData(e.target.value) } }>
          <option value="">{nome}</option>
          { 
            options.map(option => {
              if (selecionado === option.id)  
                return  <option selected key={option.id} value={option.id}>{option.descricao}</option> 
              else
                return  <option key={option.id} value={option.id}>{option.descricao}</option> 
            })
          } 
        </select>
      </div>
    </StyledSelectDinamic>
  );
}